import { render, staticRenderFns } from "./createEditBankAccounts.vue?vue&type=template&id=81847044&scoped=true&"
import script from "./createEditBankAccounts.vue?vue&type=script&lang=js&"
export * from "./createEditBankAccounts.vue?vue&type=script&lang=js&"
import style0 from "./createEditBankAccounts.vue?vue&type=style&index=0&id=81847044&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81847044",
  null
  
)

export default component.exports